import { render, staticRenderFns } from "./NameDataTableCell.vue?vue&type=template&id=ab442bf0&scoped=true"
import script from "./NameDataTableCell.vue?vue&type=script&lang=js"
export * from "./NameDataTableCell.vue?vue&type=script&lang=js"
import style0 from "./NameDataTableCell.vue?vue&type=style&index=0&id=ab442bf0&prod&scoped=true&lang=scss"
import style1 from "./NameDataTableCell.vue?vue&type=style&index=1&id=ab442bf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab442bf0",
  null
  
)

export default component.exports